import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { BulletinReport } from './bulletin-report';
import { ReportFilter } from './bulletin-report-filter';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class ReportService {

    private api_url = `${environment.ApiUrl}/report`;

    constructor(private http: HttpClient) { }

    findAll() {
        return this.http.get<BulletinReport[]>(this.api_url);
    }

    search(filter: ReportFilter){
        const url = `${this.api_url}/filter`;
        return this.http.post<BulletinReport[]>(url, filter, httpOptions);
    }

    save(report: BulletinReport) {
        return this.http.post<BulletinReport>(this.api_url, report, httpOptions);
    }

    update(report: BulletinReport) {
        return this.http.put<BulletinReport>(this.api_url, report, httpOptions);
    }

    delete(report: BulletinReport) {
        const url = `${this.api_url}/${report.id}`;
        return this.http.delete(url, httpOptions);
    }
}